import React, { useEffect } from "react";
import ProfileTab from "../components/Profile/ProfileTab";

const ProfilePage = () => {
   useEffect(() => {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    }, []);
  return (
    <React.Fragment>
      <ProfileTab />
    </React.Fragment>
  );
};

export default ProfilePage;
